import { inject, provideAppInitializer } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

export function provideAuthInitializer(
  config: Required<Pick<AuthConfig, 'clientId' | 'issuer'>> & AuthConfig,
  autoInitLoginFlow = false,
) {
  return provideAppInitializer(() => {
    const initializerFn = ((oAuthService: OAuthService) => async () => {
      oAuthService.configure({
        strictDiscoveryDocumentValidation: false,
        redirectUri: document.baseURI,
        postLogoutRedirectUri: document.baseURI,
        responseType: 'code',
        scope: 'openid profile email',
        showDebugInformation: false,
        requireHttps: 'remoteOnly',
        ...config,
      });
      oAuthService.setStorage(localStorage);

      await oAuthService.loadDiscoveryDocument();
      fixLogoutUrl(oAuthService, config.clientId);

      oAuthService.setupAutomaticSilentRefresh();
      await oAuthService
        .tryLogin()
        .catch((e) => console.error('Auth Error', e));

      if (oAuthService.hasValidAccessToken()) {
        return;
      }

      if (oAuthService.getRefreshToken()) {
        await oAuthService.refreshToken().catch((e) => {
          console.error('Error refreshing token', e);
        });
      }

      if (!oAuthService.hasValidAccessToken() && autoInitLoginFlow) {
        oAuthService.initLoginFlow();
      }
    })(inject(OAuthService));
    return initializerFn();
  });
}

function fixLogoutUrl(oAuthService: OAuthService, clientId: string) {
  if (!oAuthService.logoutUrl) {
    return;
  }

  const logoutUrl = new URL(oAuthService.logoutUrl);
  if (
    logoutUrl.searchParams.get('client_id') &&
    logoutUrl.searchParams.get('logout_uri')
  ) {
    return;
  }

  logoutUrl.searchParams.set('client_id', clientId);
  logoutUrl.searchParams.set('logout_uri', document.baseURI);
  oAuthService.logoutUrl = logoutUrl.toString();
}
